import netsHeader from './nets-header';

export default angular
  .module('app.header', [])
  .component('netsHeader', netsHeader);
